import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';

import { SharedModule } from 'client/app/modules/shared/shared.module';
import { FontAwesome } from 'client/app/modules/font-awesome/font-awesome.module';

import { MyKeysRoutingModule } from './my-keys-routing.module';
import { LicenseKeyListComponent } from './license-key-list/license-key-list.component';
import { ShareLicenseKeysFormComponent } from './share-license-keys-form/share-license-keys-form.component';
import { LicenseMultiComponent } from './license-multi/license-multi.component';
import { MyOrgBillingCodesFormComponent } from './my-org-billing-codes-form/my-org-billing-codes-form.component';
import { LicenseMultiNewComponent } from './license-multi-new/license-multi-new.component';

@NgModule({
	declarations: [LicenseKeyListComponent, ShareLicenseKeysFormComponent, LicenseMultiComponent, MyOrgBillingCodesFormComponent, LicenseMultiNewComponent],
	imports: [
		MyKeysRoutingModule,
		CommonModule,
		ReactiveFormsModule,
		NgbModule,
		NgSelectModule,
		ClipboardModule,
		SharedModule,
		FontAwesome
	]
})
export class MyKeysModule { }
